<div class="price-group-header" edsFlexbox>
  <div
    class="price-group-header__toggle"
    edsPadding
    edsPaddingRight="xs"
    edsPaddingTop="md"
    edsPaddingBottom="sm"
    edsFlexbox
    justifyContent="space-between"
    flexDirection="column"
  >
    <p class="small price-group-header__toggle-label spacing--xs">
      {{ "products.ppss-all-prices" | translate }}
    </p>
    <p class="price-group-header__toggle-label small text-grey1 spacing--none">
      {{ priceAsOf }}
    </p>
  </div>
</div>
